export enum Annex {
  A = 'A',
  B = 'B',
}

export enum ChannelType {
  ANALOG_VIDEO = 'ANALOG_VIDEO',
  DIGITAL_VIDEO = 'DIGITAL_VIDEO',
  DOCSIS = 'DOCSIS',
  // OFDM = 'OFDM', // Commented as there is yet a decision on what to do with OFDM
  OTHER = 'OTHER',
  VOD = 'VOD',
  UNKNOWN = 'UNKNOWN',
  DS = 'DS',
  QAM= 'QAM'
}

export enum JobStatus {
  COMPLETE = 'Complete',
  CANCELLED = 'Cancelled'
}
